import cloudflareLoader from "@/lib/cloudflare-images";
import clsx from "clsx";
import Image from "next/image";

interface OnboardingStepImageProps {
  currentStepKey: string;
  imageUrl: string;
  currentStep: {
    isFollowUpStep?: boolean;
  };
}

/**
 * Image component for onboarding steps displayed on the right side.
 * Handles different layouts for welcome step, follow-up steps, and regular steps.
 */
const OnboardingStepImage = ({
  currentStepKey,
  imageUrl,
  currentStep,
}: OnboardingStepImageProps) => {
  if (!imageUrl) return null;

  // Welcome step image
  if (currentStepKey === "welcome") {
    return (
      <div
        className={clsx(
          "OnboardingStepImage relative order-1 w-full overflow-hidden bg-white lg:order-2 lg:h-full lg:w-1/2",
          "hidden lg:block"
        )}
      >
        <div className="relative h-full w-full [clip-path:polygon(0%_0%,100%_0%,100%_90%,0%_100%)] lg:[clip-path:none]">
          <Image
            src={imageUrl}
            alt="Welcome step"
            fill
            className="object-cover"
            priority
          />
        </div>
      </div>
    );
  }

  // Other steps image
  return (
    <div
      className={clsx(
        "OnboardingStepImage order-1 w-full bg-zinc-50 lg:order-2 lg:h-full lg:w-1/2",
        "hidden items-center justify-center lg:flex"
      )}
    >
      {currentStep?.isFollowUpStep ? (
        currentStepKey.startsWith("cookingHabitsFollowUp") ? (
          <div className="relative w-full max-w-[260px] bg-zinc-50 px-2 py-6">
            <div className="relative aspect-[9/16] w-full overflow-hidden">
              <Image
                src={imageUrl}
                alt="Cooking Habits follow-up"
                fill
                className="object-cover"
                priority
                loader={cloudflareLoader}
              />
            </div>
          </div>
        ) : (
          <div className="relative aspect-[16/9] w-full max-w-4xl bg-zinc-50 px-6 py-8">
            <Image
              src={imageUrl}
              alt="Follow-up image"
              fill
              className="rounded-xl object-cover"
              priority
              loader={cloudflareLoader}
            />
          </div>
        )
      ) : (
        <div className="relative h-full w-full [clip-path:polygon(0%_0%,100%_0%,100%_90%,0%_100%)] lg:[clip-path:none]">
          <Image
            src={imageUrl}
            alt="Onboarding step"
            fill
            className="scale-[1.01] object-cover"
            priority
            loader={cloudflareLoader}
          />
        </div>
      )}
    </div>
  );
};

export default OnboardingStepImage;
